import { Reveal } from "./Reveal";

const SERVICES = [
  {
    num: "01",
    title: "Supply Chain Optimisation",
    copy: "End-to-end review of your supply chain — network design, inventory, freight and planning — to cut cost, reduce risk and lift service levels.",
    points: ["Network & inventory reviews", "Freight & distribution strategy", "Planning & S&OP uplift"],
  },
  {
    num: "02",
    title: "Logistics & Operational Support",
    copy: "Hands-on senior support across transport, warehousing and distribution — steadying day-to-day performance and leading improvement programs.",
    points: ["Transport & warehouse performance", "3PL management & transitions", "Operational readiness"],
  },
  {
    num: "03",
    title: "In-Country Value (ICV)",
    copy: "Practical ICV strategy, plans and reporting that stand up to scrutiny — building genuine Australian industry capability into your bids and programs.",
    points: ["ICV strategy & plans", "ICV / AIC reporting", "Local supplier development"],
  },
  {
    num: "04",
    title: "Procurement & Commercial",
    copy: "Independent procurement and commercial support — sourcing strategies, tender management, contract negotiation and supplier governance.",
    points: ["Category & sourcing strategy", "Tender & evaluation support", "Contract & supplier management"],
  },
  {
    num: "05",
    title: "Problem Solving & Manager Support",
    copy: "Experienced extra capacity for your management team — diagnosing defined problems, mentoring leaders and getting stalled initiatives moving again.",
    points: ["Rapid problem diagnosis", "Executive mentoring", "Interim management capacity"],
  },
  {
    num: "06",
    title: "Assurance & Operational Efficiency",
    copy: "Independent assurance reviews and efficiency programs that give boards and executives confidence their operations will deliver.",
    points: ["Operational assurance reviews", "Process & cost efficiency", "Risk & compliance uplift"],
  },
];

const EXPERTISE = [
  "Logistics Support Design",
  "Supply Chain Optimisation",
  "Blind Spot Analysis",
  "Commercial & Procurement",
  "Program Management",
  "Operational Efficiency",
  "Performance Enhancement",
  "Risk Management Solutions",
  "Compliance Advisory",
  "Solutions Development",
];

export default function Services() {
  return (
    <section id="capabilities" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-teal-400 font-medium">
            Capabilities
          </p>
          <h2 className="mt-4 font-display text-3xl md:text-5xl tracking-tight leading-tight text-slate-50 max-w-3xl">
            Six disciplines. One senior operator.
          </h2>
        </Reveal>

        <div className="mt-16">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num} delay={0.05}>
              <article
                data-testid={`service-chapter-${s.num}`}
                className="group grid grid-cols-12 gap-x-6 gap-y-4 border-t border-white/10 py-10 md:py-12 hover:bg-white/[0.02] transition-colors duration-500"
              >
                <div className="col-span-12 md:col-span-2">
                  <span className="font-display text-4xl md:text-5xl text-teal-400/70 group-hover:text-teal-300 transition-colors duration-500">
                    {s.num}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-4">
                  <h3 className="font-display text-xl md:text-3xl font-medium text-slate-50 leading-snug">
                    {s.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-6 md:pl-6">
                  <p className="text-base md:text-lg leading-relaxed text-slate-300">{s.copy}</p>
                  <ul className="mt-5 flex flex-wrap gap-2.5">
                    {s.points.map((p) => (
                      <li
                        key={p}
                        className="rounded-full border border-white/15 px-3.5 py-1.5 text-xs md:text-sm text-slate-400 group-hover:border-teal-400/40 transition-colors duration-500"
                      >
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>

        <Reveal delay={0.05}>
          <div data-testid="expertise-index" className="mt-20 md:mt-24 grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-4">
              <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-teal-400 font-medium">
                Our expertise
              </p>
              <h3 className="mt-4 font-display text-2xl md:text-4xl tracking-tight text-slate-50">
                Delivering tailored consulting services for efficiency.
              </h3>
            </div>
            <div className="col-span-12 md:col-span-8 grid sm:grid-cols-2 gap-x-10">
              {EXPERTISE.map((item, i) => (
                <p
                  key={item}
                  data-testid={`expertise-item-${i + 1}`}
                  className="flex items-center gap-4 border-b border-white/10 py-4 text-base md:text-lg text-slate-200 hover:text-teal-300 hover:border-teal-400/40 transition-colors duration-300"
                >
                  <span className="h-2 w-2 rounded-full border border-teal-400 shrink-0" aria-hidden="true" />
                  {item}
                </p>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
